import { authHeader } from "../_helpers";
import config from "../config";
export const NCRService = {
  headsList,
  subHeadList,
  addNCR,
  getNCRByMaster,
  NcrCount,
  NcrList,
};
const baseUrl = config.apiGateway.baseUrl;
function headsList() {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  return fetch(`${baseUrl}/criminal/headsList/`, requestOptions);
}

function subHeadList(value) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(value),
  };

  return fetch(`${baseUrl}/criminal/subHeadList/`, requestOptions);
}
function addNCR(value) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(value),
  };

  return fetch(`${baseUrl}/criminal/addNCR/`, requestOptions);
}

function getNCRByMaster(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getNCRByMaster/`, requestOptions);
}
function NcrCount(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/NcrCount/`, requestOptions);
}
function NcrList(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/NcrList/`, requestOptions);
}
